import apiClient from '../common/apiClient';

export default class LoginCaptchaController {
  async Login(data) {
    try {
      return await apiClient.post('/login/captcha', data);
    } catch (error) {
      return error;
    }
  }
}
